import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

// Custom hook for periodic token verification
export const useTokenVerification = (intervalMinutes = 5) => {
  const { checkTokenValidity, isAuthenticated } = useAuth();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    // Set up periodic token verification
    const verifyInterval = intervalMinutes * 60 * 1000; // Convert to milliseconds
    
    intervalRef.current = setInterval(async () => {
      try {
        await checkTokenValidity();
      } catch (error) {
        console.error('Periodic token verification failed:', error);
      }
    }, verifyInterval);

    // Cleanup interval on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAuthenticated, checkTokenValidity, intervalMinutes]);

  // Manual verification function
  const verifyNow = async () => {
    try {
      return await checkTokenValidity();
    } catch (error) {
      console.error('Manual token verification failed:', error);
      return false;
    }
  };

  return {
    verifyNow,
  };
};

export default useTokenVerification;